import { Axios } from 'axios'

export interface UpdatePasswordService {
  updatePassword (currentPassword: string, newPassword: string): Promise<void>;
  updateInitialPassword (newPassword: string): Promise<void>;
}

export class UpdatePasswordServiceImpl implements UpdatePasswordService {
  constructor (http: Axios) {
    this.http = http
  }

  private readonly http: Axios

  async updatePassword (currentPassword: string, newPassword: string): Promise<void> {
    await this.http.post('update-password', { currentPassword: currentPassword, newPassword: newPassword })
  }

  async updateInitialPassword (newPassword: string): Promise<void> {
    await this.http.post('update-initial-password', { newPassword: newPassword })
  }
}
